import { render } from "./LayoutClient.vue?vue&type=template&id=f35cd584&scoped=true"
import script from "./LayoutClient.vue?vue&type=script&lang=js"
export * from "./LayoutClient.vue?vue&type=script&lang=js"

import "./LayoutClient.vue?vue&type=style&index=0&id=f35cd584&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35cd584"]])

export default __exports__